import { generateOptions } from '@/lib/generic.utils'
import { cloneDeep } from 'lodash'

export default {
  ownerOptions: state => {
    return generateOptions({ collection: cloneDeep(state.owners) })
  },
  vendorOptions: state => {
    return generateOptions({
      collection: cloneDeep(state.vendors),
      includeNone: true,
      sort: false,
      sortBefore: true,
      sortingOptions: {
        sortDataType: 'string',
        sortBy: 'name',
        sortOrder: 'asc'
      }
    })
  },
  productOptions: state => {
    return generateOptions({
      collection: cloneDeep(state.products),
      combineLabelWith: 'publisher.name'
    })
  },

  taskApplicability: state => state.taskApplicability,
  metaDataFields: state => state.metaDataFields
}
